import { render } from "./ProducerAreaForm.vue?vue&type=template&id=bc8c2a82"
import script from "./ProducerAreaForm.vue?vue&type=script&lang=js"
export * from "./ProducerAreaForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__